import colorUtils from "../../utils/color";

let numbersFromColor = (hex) => {
  return Object.values(colorUtils.hexToRgb(hex)).join(', ');
};

let setCommonColors = () => {
  document.documentElement.style.setProperty('--app-info', '135, 206, 235');
  document.documentElement.style.setProperty('--app-text-muted', '112, 101, 123');
  document.documentElement.style.setProperty('--app-text', '71, 64, 79');
  document.documentElement.style.setProperty('--app-text-light', '98, 98, 98');
  document.documentElement.style.setProperty('--app-text-dark', '51, 46, 56');
};

let setDefaultColors = () => {
  document.documentElement.style.setProperty('--app-text', "71, 64, 79");
  document.documentElement.style.setProperty('--app-text-light', "98, 98, 98");
  document.documentElement.style.setProperty('--app-text-dark', "51, 46, 56;");
  document.documentElement.style.setProperty('--app-text-muted', '112, 101, 123');
  document.documentElement.style.setProperty('--app-label-color', numbersFromColor("#627084"));
  document.documentElement.style.setProperty('--app-content-color', numbersFromColor('#626262'));
  document.documentElement.style.setProperty('--app-heading-color', numbersFromColor('#2c2c2c'));
  document.documentElement.style.setProperty('--app-heading-color-light', numbersFromColor('#627084'));
};

let setHighContrastColor = () => {
  document.documentElement.style.setProperty('--app-text', "0, 0, 0");
  document.documentElement.style.setProperty('--app-text-light', "0, 0, 0");
  document.documentElement.style.setProperty('--app-text-dark', "0, 0, 0");
  document.documentElement.style.setProperty('--app-text-muted', numbersFromColor('#595062'));
  document.documentElement.style.setProperty('--app-label-color', numbersFromColor("#3f4855"));
  document.documentElement.style.setProperty('--app-content-color', numbersFromColor('#000000'));
  document.documentElement.style.setProperty('--app-heading-color', numbersFromColor('#000000'));
  document.documentElement.style.setProperty('--app-heading-color-light', numbersFromColor('#000000'));
  document.documentElement.style.setProperty('--app-success', numbersFromColor('#21A35B'));
};

export {setCommonColors,setDefaultColors, setHighContrastColor};
